import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { SectionHead, StatusChip } from "@/components/common";

export const PHASES = [
  { n: "01", key: "road.p1", date: "Q4 2026", status: "in_progress",
    desc: { en: "Branding, whitepaper, legal review, tokenomics, security, website and testing.", pt: "Branding, whitepaper, revisão jurídica, tokenomics, segurança, site e testes." } },
  { n: "02", key: "road.p2", date: "Q4 2026", status: "planned",
    desc: { en: "Deployment conditioned on security, mint publication, liquidity, locks and on-chain data integration.", pt: "Implantação condicionada à segurança, publicação do mint, liquidez, locks e integração de dados on-chain." } },
  { n: "03", key: "road.p3", date: "Q1 2027", status: "planned",
    desc: { en: "Web app MVP, dashboard, wallet connection and NFT development.", pt: "MVP do aplicativo web, dashboard, conexão de carteira e desenvolvimento NFT." } },
  { n: "04", key: "road.p4", date: "Q2 2027", status: "planned",
    desc: { en: "Genesis collection, eligibility, audited mint and community benefits.", pt: "Coleção Genesis, elegibilidade, mint auditado e benefícios comunitários." } },
  { n: "05", key: "road.p5", date: "H2 2027", status: "planned",
    desc: { en: "Products, commercial partnerships and regulatory studies for cards.", pt: "Produtos, parcerias comerciais e estudos regulatórios para cartões." } },
  { n: "06", key: "road.p6", date: "2028", status: "planned",
    desc: { en: "Utility expansion, mobile app and new integrations.", pt: "Expansão de utilidades, app móvel e novas integrações." } },
];

export function RoadmapTimeline({ withHead = true }) {
  const { t, lang } = useLang();
  return (
    <section className="py-24" data-testid="roadmap-section">
      {withHead && (
        <div className="section-pad">
          <SectionHead eyebrow={t("road.eyebrow")} title={t("road.title")} />
        </div>
      )}
      <div className="mt-12 overflow-x-auto pb-6 [scrollbar-width:thin]">
        <div className="section-pad flex min-w-max gap-5">
          {PHASES.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-surface relative w-72 shrink-0 p-6"
              data-testid={`roadmap-phase-${p.n}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-3xl text-gold/40">{p.n}</span>
                <StatusChip status={p.status} label={t(`road.status.${p.status === "in_progress" ? "progress" : p.status}`)} />
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold uppercase tracking-wide text-paper">{t(p.key)}</h3>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-neon">{p.date}</p>
              <p className="mt-3 text-xs leading-relaxed text-mist">{p.desc[lang]}</p>
              <div aria-hidden="true" className="absolute -left-5 top-1/2 hidden h-px w-5 bg-gradient-to-r from-gold/40 to-transparent first:hidden lg:block" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
